import styled from 'styled-components'

import { fromSize } from 'mf-ui-components'

import { hideBlockAt, marginBreakpoints } from '../../../../utils/commonAttrs'
import { spacing } from '../../../../utils/ui/spacing'

export const Container = styled.div<{
  marginBottom: number | undefined
  hiddenAt: string | undefined
}>`
  width: 100%;
  ${(props) => hideBlockAt(props)};
  ${(props) => marginBreakpoints(props)};
`

export const ChartContainer = styled.div`
  width: 100%;
  height: 350px;
  display: inline-block;

  & > div > div:first-of-type {
    display: none;
  }

  ${fromSize('md')} {
    height: 525px;
    padding: ${spacing('xl')} ${spacing('xs')};

    & > div > div:first-of-type {
      display: flex;
    }
  }
`

export const RiskLevelContainer = styled.div`
  margin-bottom: ${spacing('lg')};

  ${fromSize('md')} {
    margin-bottom: ${spacing('3xl')};
  }
`

export const ContributionFields = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: ${spacing('md')};
  width: 100%;

  ${fromSize('md')} {
    flex-direction: column;
    align-items: unset;
    gap: unset;
  }
`

export const ContributionFieldWrapper = styled.div`
  width: 50%;

  ${fromSize('md')} {
    width: 100%;
  }
`

export const RegularScreenTimeSelector = styled.div`
  display: none;

  ${fromSize('md')} {
    display: block;
    width: 100%;
  }
`
export const SmallScreenTimeSelector = styled.div`
  display: flex;
  width: 100%;

  ${fromSize('md')} {
    display: none;
  }
`

export const RegularScreenForm = styled.div`
  display: none;

  ${fromSize('md')} {
    display: block;
  }
`
export const SmallScreenForm = styled.div`
  display: block;

  ${fromSize('md')} {
    display: none;
  }
`

export const MobileChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('md')};
  width: 100%;
`
